import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** Shared by every "download this as a file" flow (WorkDocument PDF
 * export, Session Notes PDF export, ...) — a plain <a href> can't carry
 * the Authorization header these endpoints require, so the caller
 * fetches the blob itself and this just drives the browser's native
 * save-as via a throwaway object URL. */
export function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
